export function getFocusables(node:HTMLElement):HTMLElement[] {
  if (!node) {
    return [];
  }

  const universe = Array.from(node.querySelectorAll('input, button, select, textarea, a[href], [tabindex]')) as HTMLElement[];
  return universe.filter(item => item.tabIndex >= 0);
}